/**
 * מי נכנס לקטלוג ולמחשבונים — כולם חוץ ממנהלת המשרד (אלי 07/10/2026).
 * בקובץ משלו (02/11/2026) כדי שהנתב לא יגרור את כל catalogLibrary לקובץ הראשי.
 */
export const CATALOG_ROLES = [
  'PRODUCTION_WORKER', 'VIEWER', 'ENGINEER', 'ENG_MANAGER', 'SERVICE_MGR', 'PURCHASER', 'WAREHOUSE', 'PM', 'VP', 'MANAGER', 'CEO',
] as const;
